export const WareCardData = [
    {
        name:'Warehouse Name Here',
        type:'3PL',
        timing:'7AM - 9PM',
        operator:'name of operator',
        contact:'405687954',
        rate:'40%',
        pending:'40',
        outgoing:'50',
        delivered:'89',
        returned:'04'
    },
    {
        name:'Warehouse Name Here',
        type:'3PL',
        timing:'7AM - 9PM',
        operator:'name of operator',
        contact:'405687954',
        rate:'40%',
        pending:'40',
        outgoing:'50',
        delivered:'89',
        returned:'04'
    },
    {
        name:'Warehouse Name Here',
        type:'3PL',
        timing:'7AM - 9PM',
        operator:'name of operator',
        contact:'405687954',
        rate:'40%',
        pending:'40',
        outgoing:'50',
        delivered:'89',
        returned:'04'
    },
    {
        name:'Warehouse Name Here',
        type:'3PL',
        timing:'7AM - 9PM',
        operator:'name of operator',
        contact:'405687954',
        rate:'40%',
        pending:'40',
        outgoing:'50',
        delivered:'89',
        returned:'04'
    },
    {
        name:'Warehouse Name Here',
        type:'3PL',
        timing:'7AM - 9PM',
        operator:'name of operator',
        contact:'405687954',
        rate:'40%',
        pending:'40',
        outgoing:'50',
        delivered:'89',
        returned:'04'
    }
]